import { requireStateInputCountries } from 'pages/shared/Settings/Billing/constants';

interface Props {
  paymentMethod?: PaymentMethod | BillingInformation;
  context: PortalContext;
  isInvoiceWeChooose?: boolean;
  isInvoiceDefaultPaymentMethod?: boolean;
  country: string | undefined;
  businessRegistrationNumber?: string;
}
const isBillingAddressInvalid = ({ paymentMethod, context, isInvoiceDefaultPaymentMethod, isInvoiceWeChooose, country }: Props): boolean => {
  if (context === 'wechooose' && !country) {
    return true;
  }

  if (context === 'connect' || (isInvoiceDefaultPaymentMethod && isInvoiceWeChooose)) {
    const invoice = context === 'connect' ? (paymentMethod as BillingInformation) : (paymentMethod as PaymentMethod)?.invoice;
    return (
      !invoice?.address?.line1 ||
      !invoice?.address?.countryCodeIso2 ||
      !invoice?.address?.city ||
      (requireStateInputCountries.includes(invoice?.address?.countryCodeIso2) ? !invoice?.address?.state : false)
    );
  }
  return false;
};

function isPaymentMethodInvalid({
  paymentMethod,
  context,
  isInvoiceWeChooose,
  isInvoiceDefaultPaymentMethod,
  country,
  businessRegistrationNumber,
}: Props): boolean {
  if (!paymentMethod) {
    return true;
  }

  if (context === 'wechooose' && !country) {
    return true;
  }

  if (context === 'connect' || (isInvoiceDefaultPaymentMethod && isInvoiceWeChooose)) {
    const invoice = context === 'connect' ? (paymentMethod as BillingInformation) : (paymentMethod as PaymentMethod)?.invoice;
    const isMissingBusinessRegistrationNumber = context === 'connect' ? false : !businessRegistrationNumber;
    const isAddressInvalid = isBillingAddressInvalid({ paymentMethod, context, isInvoiceWeChooose, isInvoiceDefaultPaymentMethod, country });
    return !invoice?.billingEmail || !invoice?.contact?.email || isAddressInvalid || isMissingBusinessRegistrationNumber;
  }

  const isNotStripePaymentMethod = (paymentMethod as PaymentMethod)?.type?.toLocaleLowerCase() !== 'stripe';

  if (isNotStripePaymentMethod) {
    return false;
  }
  const isPaymentMethodDeleted = (paymentMethod as PaymentMethod)?.deleted;
  const isPaymentMetodInvalid = (paymentMethod as PaymentMethod)?.status?.toLowerCase() !== 'valid';
  return isPaymentMethodDeleted || isPaymentMetodInvalid;
}

export { isPaymentMethodInvalid, isBillingAddressInvalid };
